import {useState} from 'react'
import {Checkbox, Divider} from 'antd'

import './Filter.scss'
import {Text, Overlay, Dropdown, UserAvatar} from 'common/components'
import {maybePluralize} from 'common/helpers'
import {FilterItem} from 'common/types'

interface FilterProps {
  values: string[]
  alignRightDropdown?: boolean
  allTitle?: string
  label: string
  items: FilterItem[]
  disabled?: boolean
  renderButton: (label: string) => JSX.Element
  setValues: (values: string[]) => void
}

interface AllCheckProps
  extends Pick<FilterProps, 'values' | 'items' | 'setValues'> {
  title: string
}

const AllCheck = ({title, values, items, setValues}: AllCheckProps) => {
  const handleChange = () => setValues([])

  return (
    <>
      <Checkbox
        className="Filter-Check Filter-Check_all"
        checked={!values.length}
        indeterminate={items.length === values.length}
        disabled={!values.length}
        onChange={handleChange}
      >
        All {title}
      </Checkbox>
      <Divider className="Filter-Divider" />
    </>
  )
}

export default function Filter({
  values,
  alignRightDropdown,
  allTitle,
  label,
  items,
  disabled,
  renderButton,
  setValues,
}: FilterProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleChange = (e: any) => {
    const currentValue: string = e.target.name
    const newValues = values.includes(currentValue)
      ? values.filter((value) => value !== currentValue)
      : [...values, currentValue]
    setValues(newValues)
  }

  const sotedItems = items.slice()
  sotedItems.sort((a, b) =>
    a.label > b.label ? 1 : a.label < b.label ? -1 : 0
  )

  const buttonLabel = values.length
    ? values.length > 1
      ? maybePluralize(
          values.length,
          label,
          label.endsWith('s') ? 'es' : undefined
        )
      : sotedItems.find((item) => item.value === values[0]).label
    : label

  return (
    <Dropdown
      open={isOpen}
      placement={alignRightDropdown ? 'bottomRight' : undefined}
      dropdownRender={() => (
        <Overlay>
          {allTitle && (
            <AllCheck
              title={allTitle}
              items={sotedItems}
              values={values}
              setValues={setValues}
            />
          )}
          <ul className="Filter-List">
            {sotedItems.map((item) => (
              <li key={item.value} className="Filter-Item">
                <Checkbox
                  className="Filter-Check"
                  name={item.value}
                  checked={values.includes(item.value)}
                  onChange={handleChange}
                >
                  <span>
                    {item.image !== undefined && (
                      <UserAvatar
                        className="Filter-Image"
                        src={item.image}
                        size={24}
                        alt={item.label}
                      />
                    )}
                    {item.label}
                  </span>
                  {item.tip && (
                    <Text as="span" size="xs" color="grey" ml={16}>
                      {item.tip}
                    </Text>
                  )}
                </Checkbox>
              </li>
            ))}
          </ul>
        </Overlay>
      )}
      disabled={disabled}
      onOpenChange={setIsOpen}
    >
      {renderButton(buttonLabel)}
    </Dropdown>
  )
}
